import { Outlet, Link } from 'react-router-dom';
import { Wallet } from 'lucide-react';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left side - branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary-600 text-white flex-col justify-between p-12">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <Wallet className="h-8 w-8" />
            <span className="text-2xl font-bold">PerFin</span>
          </Link>
        </div>

        <div>
          <h1 className="text-4xl font-bold mb-4">
            Your Personal Finance & Productivity Hub
          </h1>
          <p className="text-lg text-primary-100">
            Manage your tasks, track transactions, take notes, and never miss important dates.
            All in one place.
          </p>
        </div>

        <div className="text-sm text-primary-200">
          &copy; {new Date().getFullYear()} PerFin. All rights reserved.
        </div>
      </div>

      {/* Right side - auth form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-gray-50">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden mb-8 text-center">
            <Link to="/" className="inline-flex items-center gap-2 text-primary-600">
              <Wallet className="h-8 w-8" />
              <span className="text-2xl font-bold">PerFin</span>
            </Link>
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}
